var map = {
	"./chicken.png": "c61c",
	"./deer.png": "b719",
	"./dog.png": "c1a9",
	"./fox.png": "7355",
	"./lion.png": "0c2b",
	"./llama.png": "2d36",
	"./mouse.png": "deec",
	"./pig.png": "a696",
	"./rabbit.png": "e7ef",
	"./raccoon.png": "a299",
	"./sheep.png": "1202",
	"./tiger.png": "5b86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a864";